import React from 'react';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import TpInstanceService from '../../../../Services/TpInstanceService';

export default class ThirdPartySourceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    forTpClientLinking: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    const noTpClientLinkingSources = ['Apollo'];

    TpInstanceService.GetThirdPartyInstanceList()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((source) => {
          if (this.props.forTpClientLinking && noTpClientLinkingSources.includes(source.thirdPartySourceName)) {
            return;
          }
          optValues.push({
            label: source.thirdPartySourceName,
            value: source.thirdPartySourceName,
            disabled: false,
          });
        });
        // Order by label alphabetically, but keep the default option at the top
        optValues.sort((a, b) => {
          if (a.value === '') return -1;
          if (b.value === '') return 1;
          return a.label.localeCompare(b.label);
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TPSS53');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
        showSelectFilterAt={this.props.showSelectFilterAt}
      />
    );
  }
}
